import { useCallback } from "react";
import useAtomAssistEventHandlers from "src/views/assistant/hooks/useAtomAssistEventHandlers";
import { useVnvAssistStore } from "../store/VnvAssistStore";
import { StreamingState } from "src/reusable/Chat/ChatStreaming/stores/StreamingStore";

const useVnvAssistEventHandlers = () => {
  const { metadataHandler: atomAssistMetadataHandler, messageHandler } =
    useAtomAssistEventHandlers();

  const setDialogueId = useVnvAssistStore((state) => state.setDialogueId);

  const metadataHandler = useCallback(
    (metadata: any, streamingState: StreamingState) => {
      if (metadata?.dialogue_id) {
        setDialogueId(metadata.dialogue_id);
      }
      atomAssistMetadataHandler(metadata, streamingState);
    },
    [setDialogueId, atomAssistMetadataHandler],
  );

  return { metadataHandler, messageHandler };
};

export default useVnvAssistEventHandlers;
